import React, { useState } from 'react';
import styles from '../../styles/Ariba.module.css';
import Breadcrumbs from '../../components/ui/Breadcrumbs.tsx';

// 1. Importa tus secciones
import {
    CommerceApiContent,
    SourcingApiContent,
    SlpApiContent,
    AribaTutorial,
    ActivAPi
} from './sections/index.ts';


type ApiSection = 'overview' | 'activAPI' | 'commerce' | 'sourcing' | 'slp' | 'buying';


export default function AribaApis({ setPage }: { setPage: (page: string) => void }) {
    const [activeSection, setActiveSection] = useState<ApiSection>('overview');

    // 2. Mapeo de componentes: Aquí asocias el ID con el Componente
    const components: Record<ApiSection, React.ReactNode> = {
        overview: <AribaTutorial />,
        activAPI: <ActivAPi />,
        commerce: <CommerceApiContent />,
        sourcing: <SourcingApiContent />,
        slp: <SlpApiContent />,
        buying: <div className="text-white">Próximamente...</div>, // Placeholder
    };

    const menuItems = [
        { id: 'overview', label: 'Activación del portal', icon: 'ℹ️' },
        { id: 'activAPI', label: 'Activación de APIs', icon: 'ℹ️' },
        { id: 'commerce', label: 'Commerce Automation', icon: '📄' },
        { id: 'sourcing', label: 'Sourcing & Contracts', icon: '📊' },
        { id: 'slp', label: 'Supplier Mgmt (SLP)', icon: '🧑‍💼' },
        { id: 'buying', label: 'Guided Buying', icon: '🛒' },
    ];

    return (
        <main className={`${styles.mainContainer} flex flex-col h-screen overflow-hidden`}>
            {/* Luces de fondo decorativas */}
            <div className={`${styles.blob} top-[-10%] left-[-5%] w-[500px] h-[500px] bg-blue-900/30`} />
            <div className={`${styles.blob} bottom-0 right-0 w-[400px] h-[400px] bg-purple-900/20`} />

            {/* 🥖 ESTO ES LO QUE TE FALTABA: EL BREADCRUMB */}
            <div className="relative z-20 px-8 pt-6">
                <Breadcrumbs currentPage="ariba-apis" setPage={setPage} />
            </div>

            {/* Header opcional si quieres un título antes del buscador */}
            <header className="relative z-10 px-8 mt-4 mb-4">
                <h1 className="text-3xl font-bold text-white flex items-center gap-3">
                    <span className="text-4xl">🔗</span> SAP Ariba API Explorer
                </h1>
            </header>

            <div className="relative z-10 flex flex-1 p-8 gap-8 overflow-hidden">
                {/* --- SIDEBAR --- */}
                <aside className="w-72 bg-white/5 backdrop-blur-xl border border-white/10 rounded-[2rem] p-6 flex flex-col gap-2">
                    <p className="text-xs font-bold text-gray-500 uppercase tracking-widest mb-4 px-4">
                        Soluciones
                    </p>
                    {menuItems.map((item) => (
                        <button
                            key={item.id}
                            onClick={() => setActiveSection(item.id as ApiSection)}
                            className={`flex items-center gap-4 px-4 py-3 rounded-xl transition-all duration-300 ${activeSection === item.id
                                    ? 'bg-blue-600 text-[#fff] shadow-[0_0_20px_rgba(59,130,246,0.4)]'
                                    : 'text-gray-400 hover:bg-white/10 hover:text-white'
                                }`}
                        >
                            <span className="text-xl">{item.icon}</span>
                            <span className="font-medium">{item.label}</span>
                        </button>
                    ))}
                </aside>

                {/* --- CONTENIDO DINÁMICO --- */}
                <section className="flex-1 bg-white/5 backdrop-blur-md border border-white/10 rounded-[2rem] p-6 overflow-y-auto custom-scrollbar">
                    {components[activeSection] || <ApiOverview />}
                </section>
            </div>
        </main>
    );
}

// El ApiOverview lo puedes dejar aquí abajo o sacarlo a su propio archivo también
const ApiOverview = () => (
    <div className="animate-fadeIn">

    </div>
);